import { useEffect, useState } from 'react';
import debounce from '../utils/debounce';

const isMobile = (breakpoint = 991): boolean => {
    const { innerWidth } = window;

    return innerWidth < breakpoint;
};

const useIsMobile = (breakpoint?: number) => {
    const [mobile, setMobile] = useState(isMobile(breakpoint));

    const observeScreenWidth = () => {
        setMobile(isMobile(breakpoint));
    };

    useEffect(() => {
        const resizer = debounce(observeScreenWidth, 100);

        window.addEventListener('resize', resizer);

        return () => {
            window.removeEventListener('resize', resizer);
        }
    }, []);

    return mobile;
};

export default useIsMobile;
